import Form from 'react-bootstrap/Form'
import { useId } from 'react'

export type CheckboxFieldProps = {
    label: string
    checked: boolean
    onChange: (checked: boolean) => void
    helpText?: string
    error?: string
    disabled?: boolean
}

export function CheckboxField({ label, checked, onChange, helpText, error, disabled }: CheckboxFieldProps) {
    const id = useId()

    return (
        <Form.Group className="mb-3" controlId={id}>
            <Form.Check
                type="switch"
                label={label}
                checked={checked}
                disabled={disabled}
                isInvalid={!!error}
                onChange={(event) => onChange(event.target.checked)}
            />
            {error && <div className="invalid-feedback d-block">{error}</div>}
            {helpText && !error && <Form.Text className="text-muted">{helpText}</Form.Text>}
        </Form.Group>
    )
}
